export default {
  data() {
    return {
      x: -1,
      y: -1,
      focusCheckBox: null,
      activedescendant: null
    };
  },

  computed: {
    focusIndex() {
      if (this.x === -1 || this.y === -1) {
        return -1;
      }
      return this.y * this.columnCount + this.x;
    },
    checkboxAllDisabled() {
      return this.checkboxes.every(option => option.disabled);
    }
  },

  watch: {
    focusIndex(val) {
      if (typeof val === 'number' && val > -1) {
        this.focusCheckBox = this.checkboxes[val] || {};
      } else {
        this.focusCheckBox = null;
      }
      this.checkboxes.forEach(checkbox => {
        if (this.focusCheckBox === checkbox) {
          checkbox.focus();
        }
      });
    }
  },

  methods: {
    onFocus() {
      this.leave = false;
      if (this.x === -1 && this.y === -1) {
        this.x = 0;
        this.y = 0;
        const checkbox = this.checkboxes[0];
        this.activedescendant = checkbox.itemId;
      }
      this.$nextTick(() => {
        if (!this.focusCheckBox) {
          this.checkboxes[0].focus();
        } else {
          this.focusCheckBox.focus();
        }
      });
    },
    onTab() {
      this.leave = true;
    },
    navigateCheckbox(direction) {
      const currentX = this.x;
      const currentY = this.y;
      if (this.checkboxes.length === 0 || this.checkboxAllDisabled) {
        return false;
      }
      this.bottom = false;
      this.top = false;
      this.left = false;
      this.right = false;

      if (direction === 'left') {
        if (this.x % this.columnCount === 0) {
          this.left = true;
          return false;
        }
        this.x--;
      } else if (direction === 'right') {
        if (this.focusIndex === this.checkboxes.length - 1 || (this.x + 1) % this.columnCount === 0) {
          this.right = true;
          return false;
        }
        this.x++;
      } else if (direction === 'up') {
        if (this.y === 0) {
          this.top = true;
          return false;
        }
        this.y--;
      } else if (direction === 'down') {
        if ((this.y + 1) * this.columnCount + this.x >= this.checkboxes.length) {
          this.bottom = true;
          return false;
        }
        this.y++;
      } else if (direction === 'home') {
        this.x = 0;
        this.y = 0;
      } else if (direction === 'end') {
        this.x = this.columnCount - 1;
        this.y = this.splitItems.length - 1;
      }
      const checkbox = this.checkboxes[this.focusIndex];
      this.activedescendant = checkbox.itemId;
      if (checkbox.isDisabled) {
        if (this.navigateCheckbox(direction)) {
          return true;
        } else {
          this.x = currentX;
          this.y = currentY;
          return false;
        }
      }
      return true;
    },
    reset() {
      this.x = this.y = 0;
      this.focusCheckBox = null;
    }
  }
};
